import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

import { SANITIZE_PROFILE_DEFAULT } from './default';

/**
 * The messenger is supposed to support links, images, and basic formatting. The
 * video and iframe (for embedding youtube videos for example) are technically
 * supported, but it's not supported by the backend
 */
export const SANITIZE_PROFILE_DIXA_MESSENGER: SanitizationOption = {
  allowedTags: [
    'b',
    'i',
    'strong',
    'em',
    'ul',
    'ol',
    'li',
    'br',
    'code',
    'div',
    'p',
    'pre',
    'placeholderp',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'blockquote',
    'span',
    'a',
    'img',
  ],
  allowedAttributes: {
    '*': ['dir', 'style', 'aria-*'],
    a: ['href', 'target', 'rel'],
    img: ['src', 'alt', 'width', 'height'],
    em: ['class'],
  },
  allowedClasses: {
    em: ['highlight'],
  },
  transformTags: {
    p: 'placeholderp',
  },
  allowedSchemes: SANITIZE_PROFILE_DEFAULT.allowedSchemes,
};
